import axios from "axios";

export const translateToSearch = {
  "Libros digitales": "book digital",
  "Libros físicos": "book physical",
  "Audiolibros": "audiobook",
  "Libros": "book",
  "Artículos": "artículo",
  "Películas": "film",
  "Revistas": "journal"
}

export const getFilteredResults = async (
  word,
  contentType = "",
  limit = "",
  subjects = "",
  collection = "",
  order = "",
  serie = "",
  page = 0
) => {
  let subjectsList = "";
  subjects.split("/").map(sub => subjectsList += `&subjects=${sub}`);
  try {
    const data = await axios.get(
      `${process.env.CONTENTLOAN_API_URL
      }/search/api/v1/filter?limit=${limit}&word=${word}${contentType !== "" ? `&contentType=${contentType}` : ""
      }${subjects !== "" ? `${subjectsList}` : ""}${collection !== "" ? `&collection=${collection}` : ""}${order !== "" ? `&order=${order}` : ""
      }${serie !== "" ? `&serie=${serie}` : ""}&page=${page}`
    );

    return data;
  } catch (error) {
    console.error('Error al realizar la petición:', error.message);
    return null;
  }
};

export const getFilteredResultsV2 = async (
  word,
  contentType = "",
  limit = "",
  subjects = "",
  collection = "",
  order = "",
  serie = "",
  page = 0
) => {
  let subjectsList = "";
  subjects.split("/").map(sub => subjectsList += `&subjects=${sub}`);
   return axios.get(
    `${
      process.env.CONTENTLOAN_API_URL
    }/search/api/v1/filter?limit=${limit}&word=${word}${
      contentType !== "" ? `&contentType=${contentType}` : ""
    }${subjects !== "" ? `${subjectsList}` : ""}${
      collection !== "" ? `&collection=${collection}` : ""}${
      order !== "" ? `&order=${order}` : ""
    }${serie !== "" ? `&serie=${serie}` : ""}&page=${page}`
  );
};

export const getFilteredAuthors = async (word, limit, order, page = 0) => {
  try {
    const data = await axios.get(
      `${process.env.CONTENTLOAN_API_URL
      }/search/api/v1/filter/author?limit=${limit}&word=${word}&page=${page}${order ? `&order=${order}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.error('Error al realizar la petición:', error);
    return null;
  }
}

export const getFilteredAuthorsV2 = async ( word, limit, order, page = 0) => {
  return axios.get(
    `${
      process.env.CONTENTLOAN_API_URL
    }/search/api/v1/filter/author?limit=${limit}&word=${word}&page=${page}${
      order ? `&order=${order}` : ""
    }`
  );
}

export const getDataBasesResults = async (word) => {
  const data = await axios.get(
    `${process.env.CONTENTLOAN_API_URL}/contentloan/api/v1/open-access?word=${word}`
  )
  return data
}

export const getDataBasesResultsV2 = async ( word ) => {
  return axios.get(
    `${process.env.CONTENTLOAN_API_URL}/contentloan/api/v1/open-access?word=${word}`
  )
}